import { CompanyAPI } from '@api';

const dermgLogin = async (username, password) => CompanyAPI.dermgLogin({ username, password })
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response?.data));

export { dermgLogin };
